import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GatePassGrid from './GatePassGrid';
import GatePassDetails from './GatePassDetails';
import GatePassPrint from './GatePassPrint';
import { GATE_PASS } from '../store/programs/GatePass/gatePass.reducer';
import { NAVIGATE_GATE_PASS_MASTER } from '../store/programs/GatePass/gatePass.actionsType';

/**
 * Gate Pass screen wrapper — shows the list, or the detail page of one Gate
 * Pass, the same way screens/Programs/GeneralDcNew/index.jsx switches between
 * GeneralDcHeader and GeneralDcDetails.
 */
const GatePassPage = () => {
    const dispatch = useDispatch();
    const { isGatePassDetails, isGatePassPrint } = useSelector((state) => state[GATE_PASS]);

    // Always open on the list when the menu item is clicked.
    useEffect(() => {
        dispatch({ type: NAVIGATE_GATE_PASS_MASTER });
    }, [dispatch]);

    if (isGatePassPrint) return <GatePassPrint />;
    return isGatePassDetails ? <GatePassDetails /> : <GatePassGrid />;
};

export default GatePassPage;
